export const actions = {};

export type TActions = typeof actions;
